import { inject, Injectable, Signal } from "@angular/core";
import { ViewService } from "../../../../01_core/state-management/view-service.interface";
import { ManufacturingOrderModel } from "../../../../07_feature/manufacturing-order/manufacturing-order.model";
import { ViewDataCache } from "../../../../01_core/state-management/view-data-cache";
import { ManufacturingOrderRepository } from "../../../../04_repository/manufacturing-order.repository";

const viewID = 'orders-by-ids';

export type OrderSearchResultMessageViewModel = {
  orderIDs: string[];
  orders: ManufacturingOrderModel[];
};

@Injectable({ providedIn: 'root' })
export class OrdersByIdsService implements ViewService<OrderSearchResultMessageViewModel> {

  orderSource = inject(ManufacturingOrderRepository);
  cache = inject(ViewDataCache);

  activateViewIdentity(key: string, orderIDs: string[] = []): Signal<OrderSearchResultMessageViewModel> {
    const cache = this.cache.subscribe<OrderSearchResultMessageViewModel>(viewID, key, { orderIDs, orders: [] });
    this.orderSource.getOrdersByIDs(orderIDs).then(orders => {
      cache.set({ orderIDs, orders });
    });
    return cache;
  }

  deactivateViewIdentity(key: string): void {
    this.cache.unsubscribe(viewID, key);
  }
}
